// ********************************************************
// Delivery Inspection
// Handles stuff like view and submit inspections.
// ********************************************************

import * as Backend from '@/core/backend'
import { app } from '@/main'

export async function loadCorporations () {
  const res = await Backend.callApi({
    apiName: 'Admin.LoadCorporations'
  })
  return res
}

export async function loadRegistrations (facilityId, newestRegistrationsFirst) {
  const res = await Backend.callApi({
    apiName: 'DeliveryInspection.LoadDeliveryInspections',
    inputData: {
      FacilityId: facilityId
    }
  })

  if (!res.failed && res.data) {
    if (newestRegistrationsFirst) {
      // Sort so newest is top-most
      res.data.sort((a, b) =>
        (a.WeightRegistration != null && b.WeightRegistration != null && a.WeightRegistration.DateFirst < b.WeightRegistration.DateFirst) ? 1
          : ((a.WeightRegistration != null && b.WeightRegistration != null && a.WeightRegistration.DateFirst > b.WeightRegistration.DateFirst) ? -1 : 0))
    } else {
      // Sort so newest is NOT top-most
      res.data.sort((a, b) =>
        (a.WeightRegistration != null && b.WeightRegistration != null && a.WeightRegistration.DateFirst < b.WeightRegistration.DateFirst) ? -1
          : ((a.WeightRegistration != null && b.WeightRegistration != null && a.WeightRegistration.DateFirst > b.WeightRegistration.DateFirst) ? 1 : 0))
    }
  }

  return res
}

export async function loadInspection (id) {
  const res = await Backend.callApi({
    apiName: 'DeliveryInspection.LoadDeliveryInspectionAndQuestions',
    inputData: { Id: id }
  })
  if (!res.failed) {
    if (res.data != null) {
      if (process.env.NODE_ENV === 'development') console.log('-->LoadDeliveryInspectionAndQuestions: ', res)
      const questionsFormated = []
      for (const question of res.data.Questions) {
        if (question.QuestionType === 2) {
          // Add a boolean property for the answer (the loaded answer number is a string)
          if (question.AnswerNo !== null && question.AnswerNo.toLowerCase() === 'true') { question.AnswerNoBool = true } else { question.AnswerNoBool = false }
        }
        for (const item of question.FileItems) {
          // Add a FileBytesAsBase64 that also contain the image type part
          // E.g.: from 'iVBORw0KGgoAAAANSU...' to 'data:image/png;base64,iVBORw0KGgoAAAANSU...'
          if (item.NameOfFile.toLowerCase().includes('jpg')) item.ImageData = 'data:image/jpg;base64,' + item.FileBytesAsBase64
          else item.ImageData = 'data:image/png;base64,' + item.FileBytesAsBase64
          item.FileBytesAsBase64 = null
        }
        questionsFormated.push(question)
      }
      res.data.Questions = questionsFormated
    } else {
      res.data = []
    }

    return {
      data: res.data,
      failed: false
    }
  } else {
    return res
  }
}

export async function submitInspection (params) {
  const questionsFormated = []
  let size = 0
  for (const question of params.questions) {
    for (const item of question.FileItems) {
      if (item.ImageData != null && item.ImageData !== undefined) { size = size + item.ImageData.length }
    }
  }

  // The 10% is for other payload data
  if (size * 1.1 >= 8 * 1024 * 1024) {
    app.$root.$message.showError(app.$t('Too many images'))
    return false
  }

  for (const question of params.questions) {
    if (question.QuestionType === 2) {
      // Update Answer from the boolean property
      if (question.AnswerNoBool) question.AnswerNo = 'true'
      else if (!question.AnswerNoBool) question.AnswerNo = 'false'
      else question.AnswerNo = null
    }
    for (const item of question.FileItems) {
      // Add a FileBytesAsBase64 property that only contain the base64 part
      // E.g.: from 'data:image/png;base64,iVBORw0KGgoAAAANSU...' to 'iVBORw0KGgoAAAANSU...'
      item.FileBytesAsBase64 = item.ImageData.substr(item.ImageData.indexOf(',') + 1)
      item.ImageData = null
    }
    questionsFormated.push(question)
  }

  const res = await Backend.callApi({
    apiName: 'DeliveryInspection.SubmitDeliveryInspection',
    inputData: {
      DeliveryInspection: {
        Id: params.id,
        Questions: params.questions
      }
    }
  })
  return res
}

export async function skipInspection (params) {
  const res = await Backend.callApi({
    apiName: 'DeliveryInspection.SkipDeliveryInspection',
    inputData: {
      Id: params.id
    }
  })
  return res
}

export async function blockVehicle (params) {
  console.log('pip', params)
  const res = await Backend.callApi({
    apiName: 'DeliveryInspection.BlockVehicle',
    inputData: {
      Id: params.id,
      VehicleNo: params.vehicleNo,
      Facility: params.facility
    }
  })
  return res
}

export async function setInspectionInProgress (params) {
  const res = await Backend.callApi({
    apiName: 'DeliveryInspection.SetDeliveryInspectionInProgress',
    inputData: {
      Id: params.id,
      InProgress: params.inProgress
    }
  })
  return res
}
